import { MapsetKmlFormat } from "mobility-toolbox-js/ol";
import { Map } from "ol";
import { Layer } from "ol/layer";

import { MapsetAllowedProp } from "../components/CopyPasteHandler/CopyPasteHandler";

import cloneLayer from "./cloneLayer";
import { getDegreesFromRadians } from "./styleUtils";

const KML = new MapsetKmlFormat();

const writeKml = (layer: Layer, map: Map, rotation?: number) => {
  const clone = cloneLayer(layer, map);

  let kmlString = KML.writeFeatures(clone, {
    allowedProperties: [new RegExp(`^${MapsetAllowedProp.EvtType}$`)],
    featureProjection: map.getView().getProjection(),
    resolution: map.getView().getResolution(),
  });
  if (kmlString && !!rotation) {
    kmlString = KML.writeDocumentCamera(kmlString, {
      // @ts-expect-error - fix this
      heading: getDegreesFromRadians(rotation),
    });
  }

  return kmlString;
};

export default writeKml;
